import React, { CSSProperties } from 'react';
import CommonBtn from '../common-btn';
import { BtnStyleType } from '@/utils/type';

interface IProps {
  label: string;
  type: BtnStyleType;
  link?: string;
  className?: string;
  btnWrapperClass?: string;
  labelClass?: string;
  style?: CSSProperties;
  isShowArrow?: boolean;
  buttonType?: 'button' | 'submit' | 'reset';
  children?: any;
  prefix?: any;
  suffix?: any;
  onClick?: () => void;
  [key: string]: any;
}

const BTN_STYLE_MAP = {
  primary: {
    defaultStyle: {
      background: '#3089F0',
      color: '#fff',
    },
    hoverStyle: {
      background: '#1e68c9',
    },
    activeStyle: {
      background: '#104ba3',
    },
  },
  blackBorder: {
    borderColor: '#05080D',
    defaultStyle: {
      background: '#fff',
      color: '#05080D',
    },
    hoverStyle: {
      background: '#EEEFF0',
    },
    activeStyle: {
      background: '#E0E2E5',
    },
  },
  blueBorder: {
    borderColor: '#3089F0',
    defaultStyle: {
      background: '#fff',
      color: '#3089F0',
    },
    hoverStyle: {
      background: '#F0F9FF',
    },
    activeStyle: {
      background: '#ADDCFF',
    },
  },
  gradual: {
    defaultStyle: {
      background: 'linear-gradient(135deg, #3089F0 0%, #12CEEB 100%)',
      color: '#fff',
    },
    hoverStyle: {
      background: 'linear-gradient(135deg, #196FDF 0%, #12BED9 100%)',
    },
    activeStyle: {
      background: 'linear-gradient(135deg, #156BCE 0%, #13ABC2 100%)',
    },
  },
  link: {
    defaultStyle: {
      background: 'transparent',
      color: '#3089f0',
    },
    hoverStyle: {
      background: '#eeeff0',
    },
    activeStyle: {
      background: '#e0e2e5',
    },
  },
  showcaseCommon: {
    defaultStyle: {
      background: '#723EFF',
      color: '#fff',
    },
    hoverStyle: {
      background: '#723EFF',
    },
    activeStyle: {
      background: '#723EFF',
    },
  },
};

const UsingBtn = ({
  label,
  type,
  link,
  className,
  btnWrapperClass,
  labelClass,
  style,
  isShowArrow = false,
  children,
  buttonType = 'button',
  prefix,
  suffix,
  onClick,
  ...others
}: IProps) => {
  return (
    <CommonBtn
      btnWrapperClass={btnWrapperClass}
      isShowArrow={isShowArrow}
      link={link}
      label={label}
      {...BTN_STYLE_MAP[type]}
      className={className}
      style={style}
      buttonType={buttonType}
      onClick={onClick}
      labelClass={labelClass}
      prefix={prefix}
      suffix={suffix}
      {...others}
    >
      {children}
    </CommonBtn>
  );
};
export default UsingBtn;
